import React from 'react';
import { rules } from './rules';

const check = (role: string, action: string) => {
  const permissions = rules[role];
  if (!permissions) {
    // role is not present in the rules
    return false;
  }

  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  return false;
};

interface IProtected {
  role: string;
  action: string;
  yes: Function;
  no: Function;
}

const Protected: React.FC<IProtected> = ({
 role, action, yes, no
}) => check(role, action) ? yes() : no();

export default Protected;
